import apiClient from '../../../common/functions/api_axios_instance.function';

export const createSystemPoAuthorizedRecord = async (payload) => {
  try {
    const isBulk = Array.isArray(payload);
    const url = isBulk
      ? '/systemInvoiceManagement/purchaseOrderManagement/authorized-records/bulk'
      : '/systemInvoiceManagement/purchaseOrderManagement/authorized-records';
    const response = await apiClient.post(url, payload);

    if (response.status === 200 || response.status === 201) {
      return {
        success: true,
        data: response.data?.response || response.data?.data || response.data,
        message:
          response.data?.message ||
          (isBulk ? 'POs created successfully' : 'PO created successfully'),
      };
    }

    const errorMessage = response.data?.message || response.data?.error || 'Failed to create PO';
    return { success: false, error: errorMessage, status: response.status };
  } catch (error) {
    const status = error?.response?.status;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Failed to create PO';
    return { success: false, error: errorMessage, status };
  }
};
